export const categories = [
  {
    id: 'guide',
    name: '使用指南',
    slug: 'guide',
    description: '91n平台全方位使用教程，从入门到精通',
    icon: 'ri-guide-line',
  },
  {
    id: 'address',
    name: '最新地址',
    slug: 'address',
    description: '91n官方最新入口地址实时更新',
    icon: 'ri-link',
  },
  {
    id: 'faq',
    name: '常见问题',
    slug: 'faq',
    description: '91n使用中常见问题解答汇总',
    icon: 'ri-question-answer-line',
  },
  {
    id: 'news',
    name: '平台动态',
    slug: 'news',
    description: '91n平台最新资讯与公告',
    icon: 'ri-newspaper-line',
  },
  {
    id: 'safety',
    name: '安全须知',
    slug: 'safety',
    description: '91n安全访问注意事项与防护指南',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'tips',
    name: '使用技巧',
    slug: 'tips',
    description: '91n高效使用技巧与隐藏功能发掘',
    icon: 'ri-lightbulb-line',
  },
];

export const articles = [
  {
    id: 1,
    title: '91n官方入口最新地址汇总（2026年8月更新）',
    slug: 'latest-address-2026-08',
    category: 'address',
    excerpt: '本文汇总了91n官方最新入口地址，包括主域名、备用域名及镜像站点，确保您能够安全稳定地访问91n平台。所有地址均经过官方认证，请放心使用。',
    content: `<p>欢迎来到91n官方入口导航页面。作为91n的忠实用户，我们深知找到一个稳定可靠的访问入口有多么重要。本文将为您提供<strong>91n官方最新入口地址</strong>的完整汇总，帮助您快速、安全地访问91n平台。</p>

<h2>91n官方主域名</h2>
<p>91n官方主域名是您访问平台的首选渠道。我们建议您优先使用以下官方主域名进行访问，该域名经过了严格的备案和安全认证，访问最为稳定可靠。</p>
<p>请通过搜索引擎搜索"91n官网"或直接访问91n官方认证入口，即可获取最新的主域名地址。由于网络安全政策的调整，具体域名地址可能会定期更新，建议您收藏本导航页面以获取实时信息。</p>

<h2>91n备用访问入口</h2>
<p>当主域名暂时无法访问时，91n官方提供了多个备用入口以确保服务的连续性。备用入口同样经过官方认证，您可以放心使用。以下为备用入口的相关信息：</p>
<ul>
<li>备用入口一：通过官方社交媒体账号获取最新链接</li>
<li>备用入口二：通过官方邮件订阅获取更新通知</li>
<li>备用入口三：通过官方APP内置导航功能访问</li>
</ul>

<h2>如何验证91n官方正版入口</h2>
<p>为了防止访问到仿冒网站，请您务必学会验证91n官方正版入口。以下是几个关键的验证方法：</p>
<ol>
<li><strong>检查SSL证书</strong>：正版91n网站均部署了有效的SSL安全证书，浏览器地址栏会显示安全锁图标。</li>
<li><strong>核对页面特征</strong>：正版91n网站具有独特的页面设计和功能布局，仿冒网站通常无法完全复制。</li>
<li><strong>官方渠道确认</strong>：通过91n官方社交媒体、邮件等渠道交叉验证入口地址的真实性。</li>
</ol>

<h2>91n入口访问常见问题</h2>
<p>许多用户在访问91n时会遇到各种问题，下面我们整理了最常见的几种情况及解决方案：</p>
<p>如果您发现某个入口无法访问，请不要着急。首先检查您的网络连接是否正常，然后尝试使用不同的浏览器或设备访问。如果问题依旧存在，可以尝试切换到备用入口。91n官方团队会持续监控所有入口的可用性，并在第一时间修复任何问题。</p>`,
    author: '91n官方编辑',
    publishDate: '2026-08-01',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Modern%20secure%20web%20navigation%20concept%20with%20digital%20shield%20and%20glowing%20connection%20lines%2C%20warm%20amber%20and%20teal%20accents%2C%20clean%20minimal%20design%2C%20technology%20security%20illustration%20with%20soft%20gradient%20background&width=800&height=450&seq=article-guide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '91n新用户注册与使用完整教程',
    slug: 'new-user-guide',
    category: 'guide',
    excerpt: '刚刚接触91n？不用担心！这篇详细的教程将手把手教你如何完成注册、设置个人资料，并快速上手使用91n的各项核心功能。',
    content: `<p>欢迎加入91n大家庭！如果您是第一次接触91n平台，这篇<strong>新用户注册与使用教程</strong>将帮助您快速上手。我们将从注册流程开始，逐步引导您了解91n的核心功能和使用方法。</p>

<h2>第一步：访问91n官方入口</h2>
<p>首先，您需要通过官方入口访问91n平台。请确保使用本导航站提供的官方地址，避免访问到仿冒网站。在浏览器地址栏中输入官方入口地址后，您将看到91n的首页界面。</p>

<h2>第二步：注册账号</h2>
<p>点击首页右上角的"注册"按钮，进入注册页面。注册流程非常简单：</p>
<ol>
<li>输入您的电子邮箱地址</li>
<li>设置一个安全性高的密码（建议包含大小写字母、数字和特殊字符）</li>
<li>输入验证码</li>
<li>阅读并同意用户协议和隐私政策</li>
<li>点击"立即注册"按钮</li>
</ol>
<p>注册成功后，系统会向您的邮箱发送一封验证邮件，请及时查收并完成邮箱验证。</p>

<h2>第三步：完善个人资料</h2>
<p>登录后，建议您立即完善个人资料。点击右上角的头像进入个人中心，您可以设置：</p>
<ul>
<li>个人头像</li>
<li>昵称</li>
<li>个人简介</li>
<li>偏好设置</li>
</ul>

<h2>第四步：探索91n核心功能</h2>
<p>91n平台提供了丰富的内容和服务，以下是一些核心功能的简要介绍：</p>
<p>内容浏览方面，您可以通过首页推荐、分类导航和搜索功能找到感兴趣的内容。平台会根据您的浏览习惯智能推荐相关内容，帮助您发现更多优质资源。</p>
<p>互动功能方面，您可以为喜欢的内容点赞、收藏，也可以发表评论与其他用户交流。91n鼓励积极健康的社区互动，共同营造良好的平台氛围。</p>`,
    author: '91n官方编辑',
    publishDate: '2026-07-28',
    readTime: 12,
    image: 'https://readdy.ai/api/search-image?query=Person%20using%20laptop%20with%20friendly%20onboarding%20interface%2C%20warm%20amber%20tones%2C%20modern%20flat%20design%20illustration%2C%20registration%20form%20on%20screen%2C%20clean%20minimal%20aesthetic%2C%20welcoming%20atmosphere&width=800&height=450&seq=article-guide-02&orientation=landscape',
  },
  {
    id: 3,
    title: '91n安全访问指南：保护您的账号与隐私',
    slug: 'security-guide',
    category: 'safety',
    excerpt: '网络安全不容忽视！本文详细介绍了如何安全访问91n平台，包括识别钓鱼网站、设置强密码、开启双重验证等关键安全措施。',
    content: `<p>在享受91n平台带来的优质内容的同时，<strong>账号安全与隐私保护</strong>同样不容忽视。本文将为您提供全面的91n安全访问指南，帮助您有效防范各类网络安全风险。</p>

<h2>识别官方正版入口</h2>
<p>访问91n的第一步就是要确保您使用的是官方正版入口。以下是一些关键识别方法：</p>
<ul>
<li>检查网址拼写是否正确，注意是否有字母替换（如用数字0替换字母O）</li>
<li>查看浏览器地址栏是否有安全锁标志</li>
<li>核对页面底部的备案信息</li>
<li>通过官方社交媒体渠道交叉验证</li>
</ul>

<h2>设置安全的账号密码</h2>
<p>一个强密码是保护账号安全的第一道防线。我们建议：</p>
<ol>
<li>密码长度至少12位</li>
<li>包含大小写字母、数字和特殊字符的组合</li>
<li>避免使用生日、姓名等容易被猜到的信息</li>
<li>不要在多个平台使用相同的密码</li>
<li>定期更换密码（建议每3个月更换一次）</li>
</ol>

<h2>开启双重验证</h2>
<p>91n平台支持双重验证功能，强烈建议您开启此功能。开启后，即使密码泄露，攻击者也无法轻易登录您的账号。您可以在"账号设置 - 安全设置"中找到双重验证的开启入口。</p>

<h2>防范钓鱼攻击</h2>
<p>钓鱼攻击是网络安全中最常见的威胁之一。请您注意：</p>
<ul>
<li>不要点击来源不明的链接</li>
<li>不要向任何人透露您的账号密码</li>
<li>警惕伪装成官方邮件的钓鱼邮件</li>
<li>遇到可疑情况及时联系官方客服确认</li>
</ul>

<h2>安全上网环境</h2>
<p>建议您在安全的网络环境下访问91n：</p>
<ul>
<li>避免使用公共WiFi登录账号</li>
<li>使用VPN时选择信誉良好的服务商</li>
<li>保持操作系统和浏览器的更新</li>
<li>安装可靠的安全防护软件</li>
</ul>`,
    author: '91n安全团队',
    publishDate: '2026-07-25',
    readTime: 10,
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20icon%20and%20lock%2C%20warm%20amber%20and%20teal%20gradient%20background%2C%20modern%20cybersecurity%20illustration%2C%20clean%20minimal%20design%2C%20data%20protection%20theme&width=800&height=450&seq=article-safety-01&orientation=landscape',
  },
  {
    id: 4,
    title: '91n常见问题解答（FAQ合集）',
    slug: 'faq-collection',
    category: 'faq',
    excerpt: '收集了91n用户最常遇到的问题及官方解答，包括访问问题、账号问题、功能使用等方面，帮助您快速解决使用中的困惑。',
    content: `<p>为了帮助广大用户更好地使用91n平台，我们整理了这份<strong>常见问题解答合集</strong>。如果您在使用过程中遇到问题，可以先在这里查找答案，大部分常见问题都能得到快速解决。</p>

<h2>访问相关问题</h2>

<h3>Q: 为什么我无法访问91n？</h3>
<p>A: 无法访问可能有多种原因：1）网络连接问题，请检查您的网络；2）浏览器缓存问题，请尝试清除缓存或使用无痕模式；3）地区网络限制，请尝试切换网络环境；4）入口地址已更新，请使用本导航站提供的最新地址。</p>

<h3>Q: 如何确认我访问的是正版91n？</h3>
<p>A: 正版91n网站具有以下特征：浏览器地址栏显示安全锁图标、页面底部有完整的备案信息、页面布局和功能完整。建议通过本导航站提供的官方入口访问，以确保安全。</p>

<h3>Q: 91n支持哪些浏览器？</h3>
<p>A: 91n支持所有主流浏览器，包括Chrome、Firefox、Safari、Edge等。建议使用最新版本的浏览器以获得最佳体验。</p>

<h2>账号相关问题</h2>

<h3>Q: 忘记密码怎么办？</h3>
<p>A: 在登录页面点击"忘记密码"，输入注册时使用的邮箱地址，系统会发送密码重置链接到您的邮箱。按照邮件中的指引即可重置密码。</p>

<h3>Q: 可以修改绑定的邮箱吗？</h3>
<p>A: 可以。登录后在"账号设置"中找到"安全设置"，选择"修改绑定邮箱"，按提示完成验证即可更换绑定邮箱。</p>

<h3>Q: 账号被冻结了怎么办？</h3>
<p>A: 如果您的账号被冻结，请检查是否违反了平台的使用规则。您可以通过官方客服渠道提交申诉，客服团队会在1-3个工作日内处理您的申诉。</p>

<h2>功能使用问题</h2>

<h3>Q: 如何收藏喜欢的内容？</h3>
<p>A: 在内容页面点击心形图标即可收藏。收藏后的内容可以在个人中心的"我的收藏"中查看和管理。</p>

<h3>Q: 如何订阅内容更新通知？</h3>
<p>A: 在个人设置的"通知设置"中，您可以开启内容更新通知。平台会通过站内消息或邮件（根据您的设置）通知您关注的内容更新。</p>`,
    author: '91n客服团队',
    publishDate: '2026-07-20',
    readTime: 15,
    image: 'https://readdy.ai/api/search-image?query=Frequently%20asked%20questions%20concept%20with%20question%20mark%20icons%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20modern%20customer%20support%20illustration%2C%20clean%20minimal%20design%2C%20help%20desk%20theme&width=800&height=450&seq=article-faq-01&orientation=landscape',
  },
  {
    id: 5,
    title: '91n平台2026年8月重要更新公告',
    slug: 'platform-update-2026-08',
    category: 'news',
    excerpt: '91n平台迎来重大更新！本次更新带来了全新的用户界面、优化的搜索功能和更流畅的浏览体验，让我们一起来看看有哪些新变化。',
    content: `<p>亲爱的91n用户，我们很高兴地宣布<strong>91n平台2026年8月重大更新</strong>正式上线！本次更新聚焦于用户体验的全面提升，带来了多项备受期待的新功能和改进。</p>

<h2>全新用户界面</h2>
<p>我们对平台的整体界面进行了全面升级。新的设计语言更加简洁现代，色彩搭配更加舒适，信息层级更加清晰。无论您是浏览内容还是管理个人资料，都能享受到更加流畅直观的操作体验。</p>
<p>新界面在保持91n品牌特色的同时，引入了更符合现代审美标准的设计元素。页面加载速度也得到了显著优化，平均加载时间缩短了35%。</p>

<h2>智能搜索升级</h2>
<p>搜索功能是本次更新的重点之一。新的搜索引擎支持：</p>
<ul>
<li>模糊搜索：即使输入的关键词不完全精确，也能找到相关内容</li>
<li>搜索建议：输入时实时显示搜索建议，帮助您更快找到目标</li>
<li>高级筛选：支持按时间、类型、热度等多个维度筛选搜索结果</li>
<li>搜索历史：自动保存您的搜索记录，方便重复查询</li>
</ul>

<h2>个性化推荐优化</h2>
<p>我们的推荐算法得到了重大改进。新算法能够更准确地理解您的兴趣偏好，为您推荐更加精准的内容。同时，您也可以手动调整推荐偏好，让推荐结果更符合您的期望。</p>

<h2>移动端体验提升</h2>
<p>针对移动端用户的反馈，我们对移动端界面进行了专项优化：</p>
<ul>
<li>适配各种屏幕尺寸，提供一致的使用体验</li>
<li>优化触摸操作，按钮和链接更易于点击</li>
<li>减少数据传输量，节省移动流量</li>
<li>支持PWA，可添加到手机主屏幕</li>
</ul>`,
    author: '91n官方团队',
    publishDate: '2026-08-03',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20update%20announcement%20concept%20with%20glowing%20new%20features%20icons%2C%20warm%20amber%20and%20teal%20gradient%2C%20clean%20minimal%20tech%20illustration%2C%20version%20update%20theme&width=800&height=450&seq=article-news-01&orientation=landscape',
  },
  {
    id: 6,
    title: '91n高手都在用的5个隐藏技巧',
    slug: 'pro-tips',
    category: 'tips',
    excerpt: '想要更高效地使用91n？本文揭秘了5个资深用户才知道的使用技巧，包括快捷键、批量操作、高级搜索语法等，让你的使用效率翻倍。',
    content: `<p>使用91n一段时间后，您可能已经掌握了基本功能。但您知道吗？91n还有一些<strong>隐藏的高级技巧</strong>，能让您的使用体验更上一层楼。今天我们就来分享5个资深用户都在用的实用技巧。</p>

<h2>技巧一：键盘快捷键</h2>
<p>掌握键盘快捷键是提高操作效率的最快方式。以下是几个最实用的快捷键：</p>
<ul>
<li>按 J 键：向下滚动到下一篇内容</li>
<li>按 K 键：向上滚动到上一篇内容</li>
<li>按 L 键：点赞当前内容</li>
<li>按 S 键：收藏当前内容</li>
<li>按 / 键：快速定位到搜索框</li>
</ul>

<h2>技巧二：高级搜索语法</h2>
<p>91n的搜索引擎支持多种高级搜索语法，帮助您精准定位内容：</p>
<ul>
<li>使用引号进行精确搜索，如搜索"91n官方入口"</li>
<li>使用减号排除关键词，如"91n -广告"</li>
<li>按时间范围筛选，在搜索结果页使用时间筛选器</li>
<li>按分类筛选，在搜索词后添加分类标签</li>
</ul>

<h2>技巧三：自定义首页布局</h2>
<p>您知道可以自定义首页的内容布局吗？在个人设置的"显示偏好"中，您可以：</p>
<ul>
<li>选择内容展示的密度（紧凑/标准/宽松）</li>
<li>调整推荐内容的权重比例</li>
<li>隐藏不感兴趣的版块</li>
<li>设置默认的内容排序方式</li>
</ul>

<h2>技巧四：离线阅读</h2>
<p>在没有网络的情况下也能阅读91n的内容。在文章页面点击"保存离线"按钮，系统会将文章内容缓存到本地。您可以在个人中心的"离线阅读"中查看所有已保存的内容。</p>

<h2>技巧五：数据导出</h2>
<p>91n支持导出您的个人数据，包括收藏列表、浏览历史和评论记录。在账号设置的"数据管理"中，您可以选择导出为CSV或JSON格式的文件。这个功能对于数据备份和分析使用习惯非常有用。</p>`,
    author: '91n资深用户',
    publishDate: '2026-07-15',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Productivity%20hacks%20and%20tips%20concept%20with%20lightbulb%20and%20keyboard%20shortcuts%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20modern%20flat%20design%20illustration%2C%20clean%20minimal%20aesthetic&width=800&height=450&seq=article-tips-01&orientation=landscape',
  },
  {
    id: 7,
    title: '如何通过91n官方社交媒体获取最新入口',
    slug: 'social-media-access',
    category: 'address',
    excerpt: '关注91n官方社交媒体账号，第一时间获取最新入口地址更新通知。本文列出所有官方认证的社交渠道，帮助您保持信息同步。',
    content: `<p>在入口地址发生变更时，<strong>91n官方社交媒体渠道</strong>是获取最新信息的最快途径。本文将为您列出所有经过官方认证的社交媒体账号，确保您不会错过任何重要更新。</p>

<h2>为什么要关注官方社交媒体</h2>
<p>社交媒体是91n官方发布紧急通知和重要公告的首选渠道。当主域名需要更换或出现临时访问问题时，官方会在第一时间通过社交媒体发布最新的入口地址。关注官方社交媒体可以确保您始终掌握最新的访问信息，避免因信息滞后而无法访问平台。</p>

<h2>官方认证渠道列表</h2>
<p>以下是91n官方认证的社交媒体渠道，请注意甄别真伪：</p>
<ul>
<li>官方微博：搜索"91n官方"认证账号</li>
<li>官方微信公众号：搜索"91n平台"</li>
<li>官方Telegram频道：搜索"91n_official"</li>
<li>官方邮件订阅：在官网底部输入邮箱即可订阅</li>
</ul>

<h2>如何识别官方账号</h2>
<p>为了避免关注到仿冒账号，请注意以下识别要点：</p>
<ul>
<li>查看账号是否带有官方认证标识</li>
<li>核对账号的粉丝数量和互动情况</li>
<li>查看历史发布内容是否与91n相关</li>
<li>通过91n官网提供的社交媒体链接进行跳转</li>
</ul>`,
    author: '91n官方编辑',
    publishDate: '2026-07-18',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20connection%20concept%20with%20network%20icons%2C%20warm%20amber%20and%20teal%20gradient%2C%20modern%20digital%20communication%20illustration%2C%20clean%20minimal%20design&width=800&height=450&seq=article-social-01&orientation=landscape',
  },
  {
    id: 8,
    title: '91n账号安全防护进阶指南',
    slug: 'advanced-security',
    category: 'safety',
    excerpt: '除了基础安全设置，本文介绍更高级的账号防护措施，包括登录异常监控、设备管理、API密钥管理等进阶安全功能。',
    content: `<p>在掌握了<strong>基础安全设置</strong>之后，我们来了解一些进阶的账号安全防护措施。这些功能虽然不那么显眼，但对于保护账号安全至关重要。</p>

<h2>登录异常监控</h2>
<p>91n提供了详细的登录记录查询功能。您可以在"安全设置"中查看最近30天的所有登录记录，包括登录时间、IP地址、设备信息和地理位置。如果发现可疑的登录记录，可以立即将其踢下线并修改密码。</p>
<p>建议您每周至少检查一次登录记录，确保没有异常登录行为。</p>

<h2>设备管理</h2>
<p>在"设备管理"页面，您可以查看所有已登录的设备列表。对于不再使用的设备或不认识的设备，可以远程注销登录。这个功能在以下场景特别有用：</p>
<ul>
<li>更换手机或电脑后，可以清理旧设备的登录状态</li>
<li>在公共设备上登录后，可以远程退出</li>
<li>发现可疑设备时，可以立即断开会话</li>
</ul>

<h2>安全通知设置</h2>
<p>建议您开启以下安全通知，以便第一时间获知账号的安全动态：</p>
<ul>
<li>新设备登录通知</li>
<li>密码修改通知</li>
<li>异地登录提醒</li>
<li>敏感操作验证提醒</li>
</ul>`,
    author: '91n安全团队',
    publishDate: '2026-07-12',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Advanced%20cybersecurity%20protection%20concept%20with%20multiple%20shield%20layers%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20modern%20security%20illustration%2C%20clean%20minimal%20design&width=800&height=450&seq=article-security-02&orientation=landscape',
  },
  {
    id: 9,
    title: '91n内容推荐算法揭秘',
    slug: 'recommendation-algorithm',
    category: 'tips',
    excerpt: '想知道91n是如何为您推荐内容的吗？本文深度解析91n的内容推荐机制，帮助您理解推荐逻辑，从而获得更精准的内容推送。',
    content: `<p>每天打开91n，首页总是能推荐出您感兴趣的内容。您是否好奇<strong>91n的推荐算法</strong>是如何工作的？本文将为您揭秘背后的技术原理。</p>

<h2>推荐算法的核心原理</h2>
<p>91n的推荐系统基于协同过滤与内容分析相结合的多模型融合架构。简单来说，系统会同时考虑以下因素：</p>
<ul>
<li>您过去浏览、点赞、收藏的内容特征</li>
<li>与您兴趣相似的其他用户的偏好</li>
<li>内容的时效性和热度</li>
<li>内容的多样性和覆盖面</li>
</ul>

<h2>如何优化您的推荐结果</h2>
<p>想要获得更精准的推荐？以下方法可以帮助您：</p>
<ol>
<li>积极互动：点赞、收藏和评论越多，系统越了解您的偏好</li>
<li>完善个人资料：在兴趣标签中选择您真正感兴趣的分类</li>
<li>使用"不感兴趣"功能：对不喜欢的推荐内容进行反馈</li>
<li>定期清理浏览历史：避免过时的浏览记录影响当前推荐</li>
</ol>

<h2>推荐的多样性保障</h2>
<p>91n的推荐系统不仅仅追求精准，也注重内容的多样性。系统会确保您能够接触到不同类型的优质内容，避免信息茧房效应。您可以在设置中调整"探索度"参数，更高的探索度意味着更多样化的推荐内容。</p>`,
    author: '91n技术团队',
    publishDate: '2026-07-08',
    readTime: 10,
    image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20algorithm%20concept%20with%20data%20flow%20visualization%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20modern%20tech%20illustration%2C%20clean%20minimal%20design&width=800&height=450&seq=article-algo-01&orientation=landscape',
  },
  {
    id: 10,
    title: '91n移动端APP使用全攻略',
    slug: 'mobile-app-guide',
    category: 'guide',
    excerpt: '91n移动端APP提供了与网页版同样丰富的功能体验。本文详细介绍APP的安装、配置及各项特色功能的使用方法。',
    content: `<p>除了网页版，91n还提供了功能完善的<strong>移动端APP</strong>。无论您使用的是iOS还是Android设备，都能获得流畅的使用体验。本文将为您提供91n移动端APP的完整使用攻略。</p>

<h2>APP下载与安装</h2>
<p>您可以通过以下官方渠道下载91n APP：</p>
<ul>
<li>iOS用户：在App Store搜索"91n"下载</li>
<li>Android用户：在官方网站下载APK安装包</li>
</ul>
<p>请注意，请务必通过官方渠道下载APP，避免下载到被篡改的版本。安装前请确认APP的数字签名是否完整。</p>

<h2>APP特色功能</h2>
<p>移动端APP除了保留网页版的所有功能外，还增加了一些独家特色：</p>
<ul>
<li>指纹/面部识别快速登录</li>
<li>推送通知，不错过重要更新</li>
<li>离线阅读模式，支持批量下载</li>
<li>手势操作，浏览更便捷</li>
<li>暗黑模式，夜间使用更舒适</li>
</ul>

<h2>APP与网页版的协同使用</h2>
<p>APP和网页版使用同一个账号体系，您的所有数据都会实时同步。这意味着您可以在手机上开始阅读一篇文章，然后在电脑上继续阅读，无缝切换。</p>`,
    author: '91n产品团队',
    publishDate: '2026-07-05',
    readTime: 11,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20modern%20app%20interface%20on%20screen%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20clean%20minimal%20mobile%20design%20illustration%2C%20app%20usage%20concept&width=800&height=450&seq=article-mobile-01&orientation=landscape',
  },
  {
    id: 11,
    title: '91n社区规范与行为准则',
    slug: 'community-guidelines',
    category: 'faq',
    excerpt: '为维护良好的社区环境，91n制定了详细的社区规范。了解并遵守这些规则，让我们共同营造积极向上的内容交流平台。',
    content: `<p>91n致力于打造一个<strong>积极、健康、友好</strong>的内容交流社区。为了实现这一目标，我们制定了明确的社区规范和行为准则。请所有用户在参与社区互动前仔细阅读并遵守以下规则。</p>

<h2>基本原则</h2>
<p>在91n社区中，我们倡导以下核心价值观：</p>
<ul>
<li>尊重他人：以友善、尊重的态度对待每一位社区成员</li>
<li>真诚分享：分享真实、有价值的内容和观点</li>
<li>理性讨论：在讨论中保持理性，避免情绪化表达</li>
<li>保护隐私：不公开他人隐私信息，尊重每个人的数据权利</li>
</ul>

<h2>禁止行为</h2>
<p>以下行为在91n社区中是被严格禁止的：</p>
<ul>
<li>发布违法或违规内容</li>
<li>人身攻击、辱骂或骚扰他人</li>
<li>发布垃圾广告或恶意推广信息</li>
<li>冒充他人或官方身份</li>
<li>恶意刷屏或扰乱社区秩序</li>
</ul>

<h2>违规处理</h2>
<p>对于违反社区规范的行为，91n将根据情节严重程度采取相应措施：</p>
<ul>
<li>首次轻微违规：警告并删除违规内容</li>
<li>多次违规：临时限制发言权限（1-7天）</li>
<li>严重违规：永久封禁账号</li>
</ul>`,
    author: '91n社区管理团队',
    publishDate: '2026-07-01',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Community%20guidelines%20concept%20with%20people%20collaborating%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20modern%20flat%20design%20illustration%2C%20clean%20minimal%20aesthetic&width=800&height=450&seq=article-community-01&orientation=landscape',
  },
  {
    id: 12,
    title: '91n平台发展历程与未来规划',
    slug: 'platform-history',
    category: 'news',
    excerpt: '回顾91n平台从创立至今的发展历程，了解我们走过的每一步。同时展望未来，看看91n还有哪些令人期待的发展计划。',
    content: `<p>自成立以来，<strong>91n平台</strong>始终坚持以用户为中心，不断优化产品体验，丰富内容生态。在这篇文章中，让我们一起回顾91n的发展历程，并展望未来的规划蓝图。</p>

<h2>发展历程</h2>
<p>91n的成长经历了多个重要阶段：</p>
<ul>
<li>创立初期：确定产品方向，搭建基础架构，推出核心功能</li>
<li>快速增长期：用户规模迅速扩大，内容生态逐步完善</li>
<li>品质提升期：优化产品体验，引入智能推荐，提升内容质量</li>
<li>生态建设期：拓展多元内容形式，完善社区功能，构建完整生态</li>
</ul>

<h2>核心成就</h2>
<p>在全体团队成员和广大用户的支持下，91n取得了令人瞩目的成就：</p>
<ul>
<li>累计服务用户超过百万</li>
<li>内容库涵盖数十个分类领域</li>
<li>用户平均满意度达95%以上</li>
<li>获得多项行业认可和荣誉</li>
</ul>

<h2>未来规划</h2>
<p>展望未来，91n将继续在以下方向发力：</p>
<ul>
<li>AI技术深度应用：进一步提升内容推荐的精准度</li>
<li>内容生态拓展：引入更多优质创作者和内容资源</li>
<li>国际化布局：探索海外市场，服务更广泛的用户群体</li>
<li>技术创新：持续优化平台性能和用户体验</li>
</ul>`,
    author: '91n官方团队',
    publishDate: '2026-06-28',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Company%20growth%20timeline%20concept%20with%20milestone%20markers%2C%20warm%20amber%20and%20teal%20gradient%2C%20modern%20business%20illustration%2C%20clean%20minimal%20design&width=800&height=450&seq=article-history-01&orientation=landscape',
  },
];

export const getArticleById = (id: number) => articles.find((a) => a.id === id);
export const getArticlesByCategory = (categorySlug: string) => articles.filter((a) => a.category === categorySlug);
export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);
export const getLatestArticles = (count: number) => [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
export const getRelatedArticles = (currentId: number, categorySlug: string, count: number) => articles.filter((a) => a.category === categorySlug && a.id !== currentId).slice(0, count);